import React from 'react';
import { Trophy, GlassWater, Sparkles, History, CircleDot } from 'lucide-react';
import { ISO_MAP } from '../../data/isoMap';
import { getTeamGradientDiagonal } from '../../data/teamGradients';

interface Props {
  code: string;
  size?: number;
  className?: string;
}

export function FlagRound({ code, size = 32, className = '' }: Props) {
  const iso = ISO_MAP[code];

  if (iso) {
    return (
      <span
        aria-hidden="true"
        className={`fi fi-${iso} fis inline-block rounded-full border-[1.5px] border-ink-300 shadow-xs shrink-0 bg-cover bg-center ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  // Special categories — gradient circle with icon
  const Icon =
    code === 'CC' ? GlassWater :
    code === 'EXTRAS' ? Sparkles :
    code === 'FWC_HIST' ? History :
    code === 'FWC_BOLAS' ? CircleDot :
    Trophy;
  const iconSize = Math.round(size * 0.55);
  return (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center rounded-full border-[1.5px] border-ink-300 shadow-xs shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        background: getTeamGradientDiagonal(code),
      }}
    >
      <Icon size={iconSize} className="text-white drop-shadow-sm" strokeWidth={2.25} />
    </span>
  );
}
